/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import { Button, Dropdown, Menu, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCountryNotAvailable, setEditTarget, setSetuCountry, setSetupMarketPackage } from "../../store/components/BuildTargets.slice";
import { needToConfirmSavingBuildTargets } from "../../utils/confirmation/ConfirmationHelper";
import { resetAllReportState } from "../../store/components/Reports.slice";
import { resetAllMarketExplorerConfig } from "../../store/components/MarketExplorer.slice";
import { DownOutlined } from "@ant-design/icons";
import { resetState } from "../../store/components/Minified.slice";
import { generateUserQueue, stopAllOngoingApiCall } from "../../utils/MainHelper";

const BuildTargetsFooter = function ({
    selectedCountry, selectedMP
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { editTarget } = useSelector((state) => state.buildTargets);
    const updateBuildTargetConfig = (text) => {
        generateUserQueue(selectedCountry);
        if (editTarget) {
            dispatch(setEditTarget(false));
            dispatch(resetAllReportState());
            dispatch(resetAllMarketExplorerConfig());
            stopAllOngoingApiCall();
            if (selectedMP.code.replace("dev", "") === "mediaplanning") {
                if (text === "Advanced Analysis") {
                    navigate("/advanced");
                } else {
                    dispatch(resetState());
                    navigate("/one");
                }
            } else {
                navigate("/advanced");
            }
        } else {
            if (selectedMP.code.replace("dev", "") === "mediaplanning") {
                dispatch(resetState());
                navigate("/one");
            } else {
                navigate("/advanced");
            }
        }
        dispatch(setSetuCountry(selectedCountry));
        dispatch(setSetupMarketPackage(selectedMP));
        dispatch(setCountryNotAvailable(false));
    };

    const { confirm, confirmText } = needToConfirmSavingBuildTargets({
        selectedCountry, selectedMP
    });

    const canContinue = () => selectedMP?.code && selectedCountry?.name;

    const renderItemButton = (text) => {
        const btnStyle = { padding: 0 }
        if (confirm) {
            return <Popconfirm
                placement="topRight"
                title={confirmText}
                onConfirm={updateBuildTargetConfig.bind(null, text)}
                okText="Yes"
                cancelText="No"
            >
                <Button type="link" style={btnStyle}>
                    {text}
                </Button>
            </Popconfirm>
        }
        return <Button type="link" style={btnStyle} onClick={updateBuildTargetConfig.bind(null, text)}>
            {text}
        </Button>
    }

    const countinueOptions = {
        items: [{
            label: renderItemButton("Basic Analysis"),
            key: "basicanalysis"
        }, {
            label: renderItemButton("Advanced Analysis"),
            key: "advanceanalysis"
        }]
    }
    return (
        <div className="buildtargets-footer d-flex justify-content-end align-items-center gap-1">
            {editTarget && (
                <Button
                    onClick={() => { dispatch(setEditTarget(false)); }}
                >
                    Cancel
                </Button>
            )}
            {editTarget && (selectedMP?.code?.replace("dev", "") === "mediaplanning") ?
                <Dropdown
                    disabled={!canContinue()}
                    menu={countinueOptions}
                    trigger={["click"]}
                    placement="topRight"
                    arrow
                >
                    <Button type="primary" >
                        Continue as
                        <DownOutlined />
                    </Button>
                </Dropdown> :
                <Button type="primary" disabled={!canContinue()} onClick={updateBuildTargetConfig}>
                    Continue
                </Button>
            }
        </div>
    );
};

export default BuildTargetsFooter;
